import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';

import { AuthService } from './_services/auth.service';
import { NotificationService } from './_services/notification.service';

import { Helpers } from "./helpers";

@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    encapsulation: ViewEncapsulation.None,
})

export class AppComponent implements OnInit {

    private _hubConnection: HubConnection;

    title = 'Morphica DENTAL';

    constructor(
        private _router: Router,
        private auth: AuthService,
        private notification: NotificationService) {

    }

    ngOnInit() {

        this._router.events.subscribe((route) => {

            if (route instanceof NavigationStart) {

                Helpers.setLoading(true);
                Helpers.bodyClass('boxed-layout');

            }

            if (route instanceof NavigationEnd) {

                window.scrollTo(0, 0);
                Helpers.setLoading(false);

                // Initialize page: handlers ...
                Helpers.initPage();
            }

        });

        this._hubConnection = new HubConnectionBuilder()
            .withUrl("/notify")
            .build();

        this._hubConnection
            .start()
            .then(() => console.log('Connection started!'))
            .catch(err => console.log('Error while establishing connection :('));

        this._hubConnection.on('BroadcastMessage', (message: string) => {

            if (this.auth.isLoggedIn()) {
                this.notification.updateLastNotificationsList();
            }

        });
    }

}



// WEBPACK FOOTER //
// ./ClientApp/app/app.component.ts